import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login");
            return;
        }
        const sessionId = m[1];

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                if (cancelled) return;
                setUser(data);
                window.history.replaceState({}, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: data } });
            } catch (e) {
                setError("No se pudo iniciar sesión con Google");
                setTimeout(() => navigate("/login"), 1500);
            }
        })();
        return () => { cancelled = true; };
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
            <div className="text-slate-700">{error || "Procesando inicio de sesión..."}</div>
        </div>
    );
}
